import React, { Component } from "react";
import Modal from "react-modal";
import ProductItemUpdateModalUI from "./ProductItemUpdateModalUI";
import RestApiUtils from "../../../apiclient/moebli/RestApiUtils";

class ProductItemUpdateModalSF extends Component {
	constructor(props) {
		super(props);
		this.state = {
			successMsg: null,
			errorList: null,
			submitted: false,
			productItemId: '',
			productItemIdError: null,
			priceF: '',
			priceFError: null,
			maker: '',
			makerError: null,
			itemName: '',
			itemNameError: null,
			description: '',
			descriptionError: null,
		};
	}

	render() {
		return (
			<ProductItemUpdateModalUI
				context={this.props.context}
				errorList={this.state.errorList}
				successMsg={this.state.successMsg}
				setErrorList={this.setErrorList}
				updateMode={this.props.updateMode}
				submitted={this.state.submitted}
				onCancelClick={this.onCancelClick}
				onSubmit={this.onSubmit}
				onCancelCreate={this.onCancelCreate}
				productItemId={this.state.productItemId}
				onProductItemIdChange={(event) => this.setState({ productItemId: event.target.value })}
				productItemIdError={this.state.productItemIdError}
				setProductItemIdError={(error) => this.setState({ productItemIdError: error })}
				priceF={this.state.priceF}
				onPriceFChange={(event) => this.setState({ priceF: event.target.value })}
				priceFError={this.state.priceFError}
				setPriceFError={(error) => this.setState({ priceFError: error })}
				maker={this.state.maker}
				onMakerChange={(event) => this.setState({ maker: event.target.value })}
				makerError={this.state.makerError}
				setMakerError={(error) => this.setState({ makerError: error })}
				itemName={this.state.itemName}
				onItemNameChange={(event) => this.setState({ itemName: event.target.value })}
				itemNameError={this.state.itemNameError}
				setItemNameError={(error) => this.setState({ itemNameError: error })}
				description={this.state.description}
				onDescriptionChange={(event) => this.setState({ description: event.target.value })}
				descriptionError={this.state.descriptionError}
				setDescriptionError={(error) => this.setState({ descriptionError: error })}
			/>
		);
	}

	onCancelClick = () => {
		this.setState({
			submitted: false,
			errorList: null,
		});
		this.props.onCancelClick();
	};

	componentDidMount() {
		Modal.setAppElement('body');
	}

	componentDidUpdate(prevProps) {
		const { selectedProductItem } = this.props;
		if (selectedProductItem && (!prevProps.selectedProductItem || prevProps.selectedProductItem.productItemId !== selectedProductItem.productItemId)) {
			this.setState({
				productItemId: selectedProductItem.productItemId,
				priceF: selectedProductItem.priceF,
				maker: selectedProductItem.maker,
				itemName: selectedProductItem.itemName,
				description: selectedProductItem.description,
			});
		}
	}

	onSubmit = () => {
		const { submitted } = this.state;
		if (submitted) return;

		this.setState({
			successMsg: null,
			errorList: [],
			submitted: true,
		});

		RestApiUtils.put(
			this.props.context,
			`/api/su/accounts/${this.props.account.accountId}/productItems/${this.props.selectedProductItem.productItemId}`,
			this.onSubmitCallback, {
			itemName: this.state.itemName,
			description: this.state.description,
			priceF: this.state.priceF,
			maker: this.state.maker,
		});
	};

	onSubmitCallback = (response) => {
		let errorList = []
		response.errorList.forEach(error => {
			errorList.push(error.message)
		})

		this.setState({
			successMsg: response.success,
			errorList: errorList,
			submitted: false
		})

		if (response.errorList.length === 0) {
			setTimeout(() => {
				this.setState({
					successMsg: null
				})
				this.props.onCancelClick()
				this.props.onRefreshClick()
			}, 1000)
		}
	}

	setErrorList = (errorList) => {
		this.setState({ errorList: errorList });
	};
}

export default ProductItemUpdateModalSF;
